import closeIcon from "../assets/newCloseIcon.png";

const CloseTrailer = () => {
  return (
    <span aria-hidden="true">
      <img src={closeIcon} alt="" width={10} height={10} />
    </span>
  )
}

export default CloseTrailer;
